module.exports = __webpack_public_path__ + "img/nauru.bbc94de9.svg";